import { render, staticRenderFns } from "./DesignerServicesPageContainer.vue?vue&type=template&id=af361074&"
import script from "./DesignerServicesPageContainer.vue?vue&type=script&lang=js&"
export * from "./DesignerServicesPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports